import { mapState } from "vuex";
import { getLocalAppConfig } from "@/utils/appConfig";

export default {
  computed: {
    ...mapState(["customerAccountEndDate"]),
    // 计算距离到期的天数（直接使用 Store 中的 customerAccountEndDate）
    daysUntilExpiry() {
      const endDateStr = this.customerAccountEndDate;
      if (!endDateStr) return null;
      const endDate = new Date(endDateStr);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);
      const diffTime = endDate.getTime() - today.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    },
    // 是否在30天到期提醒范围内
    shouldShow30DayNotice() {
      const days = this.daysUntilExpiry;
      return days !== null && days <= 30 && days > 3;
    },
    // 是否在3天到期提醒范围内
    shouldShow3DayNotice() {
      const days = this.daysUntilExpiry;
      return days !== null && days <= 3 && days > 0;
    },
    // 是否显示红色文字提示（30天内）
    shouldShowRedText() {
      const days = this.daysUntilExpiry;
      return days !== null && days <= 30 && days > 0;
    },
    // 到期提醒文案
    expireNoticeText() {
      const days = this.daysUntilExpiry;
      if (days === null) return "";
      // 从配置中获取短信签名
      const appConfig = getLocalAppConfig();
      let signature =JSON.parse(appConfig.extra).signature || "短信签名";
      return `【${signature}】温馨提醒：您的账号还有${days}天到期`;
    },
  },
  methods: {
    // 检查是否需要显示首次登录提示
    checkExpireNotice() {
      // 排除登录页
      if (this.$route && this.$route.path === '/login') return;
      
      const endDateStr = this.customerAccountEndDate;
      if (!endDateStr) return;

      const days = this.daysUntilExpiry;
      if (days === null || days <= 0) return;

      // 获取存储的最后提示日期
      const lastNoticeDate = localStorage.getItem("accountExpireLastNoticeDate");
      const lastNoticeDays = localStorage.getItem("accountExpireLastNoticeDays");

      // 判断是否需要显示提示
      let shouldShow = false;
      let noticeType = null;

      // 30天提醒
      if (days <= 30 && days > 3) {
        // 如果到期日期改变了，或者之前没有提示过30天，或者之前提示的是其他天数
        if (
          lastNoticeDate !== endDateStr ||
          !lastNoticeDays ||
          lastNoticeDays !== "30"
        ) {
          shouldShow = true;
          noticeType = "30";
        }
      }
      // 3天提醒
      else if (days <= 3 && days > 0) {
        // 如果到期日期改变了，或者之前没有提示过3天，或者之前提示的是其他天数
        if (
          lastNoticeDate !== endDateStr ||
          !lastNoticeDays ||
          lastNoticeDays !== "3"
        ) {
          shouldShow = true;
          noticeType = "3";
        }
      }
      if (shouldShow && noticeType) {
        // 触发全局事件显示提示
        this.$root.$emit("show-expire-notice", {
          text: this.expireNoticeText,
          days: days,
        });

        // 记录提示信息
        localStorage.setItem("accountExpireLastNoticeDate", endDateStr);
        localStorage.setItem("accountExpireLastNoticeDays", noticeType);
      }
    },
  },
  mounted() {
    // 页面加载时检查是否需要显示提示（排除登录页）
    if (this.$route && this.$route.path !== '/login') {
      this.$nextTick(() => {
        this.checkExpireNotice();
      });
    }
  },
  watch: {
    // 监听到期日期变化，如果变化了需要重新检查
    customerAccountEndDate: {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.$nextTick(() => {
            this.checkExpireNotice();
          });
        }
      },
      immediate: false,
    },
  },
};

